import "./NoPage.css";

import React, { useEffect, useState } from "react";

import axios from "axios";

import { useParams } from "react-router-dom";

import { END_URL } from "../../config";

import gg from "../../images/pp-logo.gif";

function NoPage() {

    const [page, setPage] = useState("");

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    useEffect(() => {

        const container = document.querySelector('.priv-main');

        if (!container) return;

        const handleClick = (e) => {

            if (
                e.target.tagName === 'INPUT' &&
                e.target.type === 'button'
            ) {
                const url = e.target.name;

                if (url) {
                    window.open(url, '_blank');
                }
            }
        };

        container.addEventListener('click', handleClick);

        return () => {
            container.removeEventListener('click', handleClick);
        };

    }, [page]);

    const cleanHeadingBoldTags = (html) => {

        if (!html) return "";

        const temp = document.createElement("div");

        temp.innerHTML = html;

        const headings = temp.querySelectorAll(
            "h1, h2, h3, h4, h5, h6"
        );

        headings.forEach((heading) => {

            heading.innerHTML = heading.innerHTML
                .replace(/<\/?b>/gi, "")
                .replace(/<\/?strong>/gi, "");

        });

        return temp.innerHTML;
    };

    useEffect(() => {

        fetchPage();

    }, []);

    const fetchPage = async () => {

        try {

            setLoading(true);

            const response = await axios.get( `${END_URL}/page_not_found`);
               
            if (response.data.success) {

                const pageData = response.data.data;

                setPage(pageData);

            } else {

                const pageData = response.data.data;

                setPage(pageData);
            }

        } catch (error) {

            if (
            error.response &&
            error.response.status === 404 &&
            error.response.data?.data
            ) {
                setPage(error.response.data.data);
                setError("");
            } else {
                console.error(error);
                setError("Failed to load page");
            }

        } finally {

            setLoading(false);
        }
    };

    if (loading) {

        return (
               <div className="loadingDiv" >
                
                    <img src={gg}  alt="Loading..." />
        
                </div>
        );
    }

    if (error) {

        return (
            <div className="container py-5 text-danger">
                {error}
            </div>
        );
    }

    return (
        <div className="priv-main">

            <div className="container">

                <div className="row">

                    <div className="col-md-12 priv-text-div">

                        {page && (

                            <div className="priv-text"
                               
                                dangerouslySetInnerHTML={{
                                    __html: page
                                }}
                            />

                        )}

                    </div>

                </div>

            </div>

        </div>
    );
}

export default NoPage;